import { logger } from './logger';

/**
 * A copy to the clipboard that failed, logged and tracked (Datadog Logs, Sentry and RUM). The person
 * already sees why on screen; this is so failures show up for us too. The DS copy buttons report a
 * failure without the error, so `error` defaults to one that names it.
 */
export const reportCopyFailure = (source: string, error: unknown = new Error('Copying to the clipboard failed')) => {
  logger.error('Copying to the clipboard failed', { source }, error);
};
